export const removeKeyFromObject = (obj: Record<string, any>, targetKeys: string[]) => {
  const objArr = Object.entries(obj)
  return objArr.reduce((acc, [k, v]) => {
    if (targetKeys.includes(k)) return acc
    return { ...acc, [k]: v }
  }, {})
}
